import { useState, useEffect, RefObject } from 'react';

export const useInView = (elementRef: RefObject<HTMLElement>, options = {}) => {
  // Start with isInView as false to ensure elements start invisible
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    let timeoutId: number | undefined;
    
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        // Add a small delay before showing the element
        timeoutId = window.setTimeout(() => {
          setIsInView(true);
        }, 100); // Reduced delay for mobile responsiveness
      } else if (!isInView) {
        // Make sure items that are scrolled past quickly still get a chance to be seen
        clearTimeout(timeoutId);
      }
    }, { threshold: 0.15, ...options }); // Lower default threshold for mobile
    
    const currentElement = elementRef.current;
    if (currentElement) {
      // Start observing the element
      observer.observe(currentElement);
    }
    
    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [elementRef, options, isInView]);

  return isInView;
};